import { useState, useEffect } from "react";

function useWindowSize() {
  const [deviceType, setDeviceType] = useState({
    isMobile: window.innerWidth < 768,
    isTablet: window.innerWidth >= 768 && window.innerWidth < 1024,
    isDesktop: window.innerWidth >= 1024,
  });
  useEffect(() => {
    // Handler to call on window resize
    function handleResize() {
      if (window.innerWidth >= 1024) {
        // desktop Mode
        setDeviceType({
          isDesktop: true,
          isMobile: false,
          isTablet: false,
        });
      } else if (window.innerWidth >= 768) {
        // isTablet
        setDeviceType({
          isTablet: true,
          isMobile: false,
          isDesktop: false,
        });
      } else {
        // default Mobile Mode
        setDeviceType({
          isMobile: true,
          isTablet: false,
          isDesktop: false,
        });
      }
    }

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Remove event listener on cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return deviceType;
}

export default useWindowSize;
